import { computed, inject, Injector, signal } from "@angular/core";
import { CommonForm, CommonOptionsFieldConfig, CommonSelectField } from "@eforall/common";
import { VolunteerSelectedLanguageEnum, VolunteerSelectedLanguageType } from "../../../../interfaces";
import { TrimesterService } from "../../../../services";


export interface MentorSignUpAddFields {
	trimesterId: number,
	selectedLanguage: VolunteerSelectedLanguageType,
}

export class MentorSignupAddForm {

	private readonly injector = inject(Injector);
	public readonly commonForm = new CommonForm<MentorSignUpAddFields>(this.injector);
	private trimesterService = inject(TrimesterService);
	public volunteerData = signal<{ canVolunteerInEnglish: boolean, canVolunteerInSpanish: boolean } | undefined>(undefined);

	private readonly trimesterOptions = computed(() => {

		// fallback to 0 if Programming trimester is not found(should not happen, but just in case)
		const programmingTrimesterId = this.trimesterService.trimesterWindowOptionMap.Programming?.uniqueId ?? 0;

		return this.trimesterService.allTrimesterData()
			.filter(trimester => trimester.trimesterId >= programmingTrimesterId)
			.map(trimester => ({ value: trimester.trimesterId, text: trimester.name }));
	});
	readonly trimester = computed<CommonSelectField<number | undefined>>(() => ({
		config: signal<CommonOptionsFieldConfig<number | undefined>>({
			label: 'Trimester',
			options: this.trimesterOptions(),
			isRequired: true,
			isSpanish: false
		}),
		actualValue: computed(() => this.trimesterService.trimesterWindowOptionMap.Admissions?.uniqueId),
		pendingValue: signal<number | null>(null),
		saving: signal(false),
		error: signal(''),
		formFieldName: 'trimesterId',
		form: this.commonForm,
	}));


	private readonly languageOptions = computed(() => {
		const data = this.volunteerData();
		const interestedLanguages = [];
		if (data?.canVolunteerInEnglish)
			interestedLanguages.push({ value: VolunteerSelectedLanguageEnum.EN, text: "English" });
		if (data?.canVolunteerInSpanish)
			interestedLanguages.push({ value: VolunteerSelectedLanguageEnum.ES, text: "Spanish" });
		if (data?.canVolunteerInEnglish && data.canVolunteerInSpanish) {
			interestedLanguages.push({ value: VolunteerSelectedLanguageEnum.BOTH, text: "Both" });
		}
		return interestedLanguages;
	});
	readonly language = computed<CommonSelectField<VolunteerSelectedLanguageType | undefined>>(() => ({
		config: signal<CommonOptionsFieldConfig<VolunteerSelectedLanguageType | undefined>>({
			label: 'Language',
			options: this.languageOptions(),
			isRequired: true,
			isSpanish: false
		}),
		actualValue: computed(() => undefined),
		pendingValue: signal<VolunteerSelectedLanguageType | null>(null),
		saving: signal(false),
		error: signal(''),
		formFieldName: 'selectedLanguage',
		form: this.commonForm,
	}));


}